/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const toastNodes = Array.from(document.querySelectorAll('[data-toast]'));
if (toastNodes.length) {
    import(/* webpackChunkName: "Toast" */ './components/Toast').then(({ default: Toast }) => {
        toastNodes.forEach((node) => render(<Toast {...parseDataToProps(node.dataset)} />, node));
    });
}
